import type { SVGProps } from 'react';
const SvgPartnersPage1 = (props: SVGProps<SVGSVGElement>) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={100}
      fill="none"
      className="w-full h-full"
      viewBox="0 0 100 100"
      {...props}
   >
      <path
         className="stroke-primary"
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={5}
         d="M33.8 36.386s-2.891-4.376-4.919-7.047v0c-3.484-4.588-10.374-1.125-8.762 4.406.148.508.283.897.401 1.13 1.15 2.277 3.443 5.537 3.443 5.537m9.836-4.026-.082-.265c-1.48-4.796 4.307-8.171 7.46-4.265v0c6.567 8.14 13.87 19.762 18.985 28.34 3.862 6.478 2.03 14.754-4.059 19.204l-7.188 5.255a15 15 0 0 1-18.744-.833l-1.29-1.132-11.905-12.183a12.2 12.2 0 0 1-2.237-3.173v0c-1.801-3.687 2.089-7.573 5.781-5.783v0c3.261 1.582 8.361 4.027 8.361 4.027s-8.4-11.9-12.787-20.133v0c-2.64-4.955 3.44-9.177 7.54-5.34l.33.307m9.835-4.026 8.36 13.59m-18.196-9.564 8.853 14.093M68.75 79.75c8.5-4 15-14 15-14l.794-1.587c1.72-3.441-2.166-7.193-5.794-5.913v0c-2.681.946-7 2-7 2s7.04-9.822 11.5-18v0c2.7-4.949-3.359-9.244-7.519-5.44l-.481.44m-10-4s2.939-4.347 5-7v0c3.581-4.609 10.581-1.035 8.859 4.542-.131.424-.252.751-.359.958-1.17 2.262-3.5 5.5-3.5 5.5m-10-4c1.53-4.845-4.265-8.418-7.5-4.5v0c-2.34 2.835-2 2.5-3 4m10.5.5-4.5 7.5m14.5-3.5-8.5 13"
      />
      <path
         className="stroke-primary"
         strokeLinecap="round"
         strokeWidth={4}
         d="M45.75 9.75v8M34.235 14.99l5.303 6.08M56.636 14.99l-5.303 6.08"
      />
   </svg>
);
export default SvgPartnersPage1;
